import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  AuthFacade,
  ImpersonationService,
} from '@vasta/client-core-authentication';
import { UiButtonComponent } from '@vasta/frontend-ui-buttons';
import { UiMessageComponent } from '@vasta/frontend-ui-feedback';

/**
 * Says, on every page, whose account the changes are being made in — and gives
 * the way out. Everything written while it shows is attributed to the
 * impersonated user, so the tab must never leave that unsaid.
 */
@Component({
  selector: 'cl-impersonation-banner',
  imports: [TranslocoPipe, UiMessageComponent, UiButtonComponent],
  templateUrl: './impersonation-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationBannerComponent {
  private readonly impersonation = inject(ImpersonationService);
  readonly auth = inject(AuthFacade);

  readonly visible = computed(() => this.auth.impersonatedBy() !== null);

  exit(): void {
    this.impersonation.exit();
  }
}
